module.exports = __webpack_public_path__ + "img/IMG_0459_L_WoodMatted.fff40389.jpg";